module.exports = __webpack_public_path__ + "static/AulaFree-Mobile-450x530-00fe2ab614a70d7ef44d8490d6c19dc4.png";